import { useState } from "react";
import { Link } from "react-router-dom";
import { ContributorLoginModal } from "@/components/contributor/ContributorLoginModal";
import { Logo } from "@/components/brand/Logo";
import { usePlatformSettings } from "@/hooks/usePlatformSettings";

const Footer = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { pricingEnabled } = usePlatformSettings();

  return (
    <>
      <footer className="py-12 bg-card border-t border-border">
        <div className="container px-6 mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <Logo size="md" to={null} />

            <nav className="flex items-center gap-6 text-sm">
              <a href="#features" className="text-muted-foreground hover:text-foreground transition-colors">
                Features
              </a>
              {pricingEnabled && (
                <Link to="/pricing" className="text-muted-foreground hover:text-foreground transition-colors">
                  Pricing
                </Link>
              )}
              <Link to="/how-it-works" className="text-muted-foreground hover:text-foreground transition-colors">
                How It Works
              </Link>
              <button 
                onClick={() => setShowLoginModal(true)}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Contributor Dashboard
              </button>
            </nav>

            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} Upbrief. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
      <ContributorLoginModal 
        open={showLoginModal} 
        onOpenChange={setShowLoginModal} 
      />
    </>
  );
};

export default Footer;
